.arrow {
  background-color: var(--cxy-color-midnight-blue-400);
  height: 25px;
  width: 25px;
  display: grid;
  place-items: center;
  padding: 2px;
  margin: auto 8px auto auto;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  padding-top: 0px;
  padding-bottom: 3px;
  transition: background-color 0.5s ease-in-out;
}

.arrow.open {
  background-color: var(--cxy-color-green-300);
  padding-top: 2px;
  padding-bottom: 0px;
}

.arrowIcon {
  height: 10px;
  width: 10px;
  border: 1px solid var(--cxy-color-midnight-blue-600);
  border-width: 2px 2px 0 0;
  transform: rotate(135deg);
  transition: all 0.3s ease;
}

.arrowIcon.open {
  transform: rotate(-45deg);
}
